import { useEffect, useState } from "react";
import {
  Box,
  Text,
  Flex,
  VisuallyHidden,
  chakra,
  Container,
  Button,
  IconButton,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Editable,
  EditableInput,
  EditableTextarea,
  EditablePreview,
  useEditableControls,
  Input,
  ButtonGroup,
} from "@chakra-ui/react";
import {
  FaCopy,
  FaCheckSquare,
  FaTrashAlt,
  FaCheck,
  FaEdit,
  FaWindowClose,
  FaWalking,
} from "react-icons/fa";
import { BsFillGearFill } from "react-icons/bs";
import { BeatLoader } from "react-spinners";
import { ImCross } from "react-icons/im";
import axios from "axios";
import { ReactSession } from "react-client-session";
import RpcMap from "./RpcMap";

const SocialButton = ({ children, label, href }) => {
  return (
    <chakra.button
      bg={"brand.red"}
      color={"brand.white"}
      rounded={"full"}
      w={8}
      h={8}
      cursor={"pointer"}
      as={"a"}
      href={href}
      target="_blank"
      display={"inline-flex"}
      alignItems={"center"}
      justifyContent={"center"}
      transition={"background 0.3s ease"}
      _hover={{
        bg: "brand.white",
        color: "brand.red",
      }}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </chakra.button>
  );
};

function CustomControlsExample(props) {
  /* Here's a custom control */
  function EditableControls(props) {
    const {
      isEditing,
      getSubmitButtonProps,
      getCancelButtonProps,
      getEditButtonProps,
    } = useEditableControls();

    const [deleteNow, setDeleteNow] = useState(false);

    return isEditing ? (
      <ButtonGroup justifyContent="flex-end" size="sm" width={"full"}>
        <IconButton
          icon={<FaCheck />}
          {...getSubmitButtonProps()}
          bg={"transparent"}
          border={"1px solid"}
          borderColor={"brand.red"}
          color={"brand.white"}
          _hover={{ bg: "brand.red" }}
        />
        <IconButton
          icon={<FaWindowClose />}
          {...getCancelButtonProps()}
          bg={"transparent"}
          border={"1px solid"}
          borderColor={"brand.red"}
          color={"brand.white"}
          _hover={{ bg: "brand.red" }}
        />
      </ButtonGroup>
    ) : deleteNow ? (
      <Flex justifyContent="flex-end">
        <Box as="div" display={"inline"}>
          <Text as={"span"} color={"brand.red"}>
            Delete?
          </Text>
        </Box>
        <IconButton
          size={"sm"}
          bg={"transparent"}
          border={"1px solid"}
          borderColor={"brand.red"}
          color={"brand.white"}
          _hover={{ bg: "brand.red" }}
          ms={2}
          onClick={() => props.deleteIp(props.deletevalue)}
        >
          <FaCheck size={"14"} color="#fff" />
        </IconButton>
        <IconButton
          size={"sm"}
          bg={"transparent"}
          border={"1px solid"}
          borderColor={"brand.red"}
          color={"brand.white"}
          _hover={{ bg: "brand.red" }}
          ms={2}
          onClick={() => setDeleteNow(false)}
        >
          <ImCross size={"14"} color="#fff" />
        </IconButton>
      </Flex>
    ) : (
      <Flex justifyContent="flex-end">
        <IconButton
          size="sm"
          icon={<FaEdit />}
          {...getEditButtonProps()}
          bg={"transparent"}
          border={"1px solid"}
          borderColor={"brand.red"}
          color={"brand.white"}
          _hover={{ bg: "brand.red" }}
        />
        <IconButton
          size={"sm"}
          bg={"brand.red"}
          border={"1px solid"}
          borderColor={"brand.red"}
          color={"brand.white"}
          _hover={{ bg: "brand.red" }}
          ms={2}
          onClick={() => setDeleteNow(true)}
        >
          <FaTrashAlt size={"14"} color="#fff" />
        </IconButton>
      </Flex>
    );
  }

  return (
    <Editable
      textAlign="start"
      defaultValue={props.textvalue}
      fontSize="md"
      isPreviewFocusable={false}
      onSubmit={(input) => {
        props.updateIps(props.deletevalue, input);
      }}
    >
      <Flex justifyContent="space-between" w={"100%"}>
        <Box flex={1} ps={1}>
          {props.id}.
        </Box>
        <Box flex={4}>
          <Box marginTop={"-1"}>
            <EditablePreview />
            <Input as={EditableInput} />
          </Box>
        </Box>
        <Box flex={2} w={"200px"}>
          <EditableControls
            deletevalue={props.deletevalue}
            navigate={props.navigate}
            deleteIp={props.deleteIp}
          />
        </Box>
      </Flex>
    </Editable>
  );
}

const Rpcs = (props) => {
  const [data, setData] = useState(null);
  const [errOcc, setErrOcc] = useState(false);
  const [apiKeyString, setApiKeyString] = useState("");

  const [domainList, setDomainList] = useState([]);
  const [showDomains, setShowDomains] = useState(false);
  const [showAddPanel, setShowAddPanel] = useState(false);

  const [domainAdded, setDomainAdded] = useState("");
  const [domainAddStatus, setDomainAddStatus] = useState("UNLOADED");
  //can be UNLOADED,LOADING,SUCCESS,ERROR
  const [ipAddError, setDomainAddError] = useState("");

  const [domainEditStatus, setDomainEditStatus] = useState("UNLOADED");
  const [domainEditError, setDomainEditError] = useState("");
  const [domainEditValue, setDomainEditValue] = useState("");

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/billing`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setData(res.data);
            setApiKeyString(res.data.result.api_key);
            // setActiveUrl(
            //   `https://rpc.shyft.to?api_key=${res.data.result.api_key ?? "--"}`
            // );
          } else {
            setErrOcc(true);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setErrOcc(true);
          props.setLoading(false);
        });
    } else {
      //   navigate("/get-api-key");
    }
  }, []);

  useEffect(() => {
    // setTimeout(() => {
    //   props.setLoading(false);
    // },800)
    if (data !== null || errOcc === true) props.setLoading(false);
  }, [data, errOcc]);

  //   const copyConRPC = () => {
  //     navigator.clipboard.writeText(activeUrl);
  //     setCopiedRPC(true);
  //     setTimeout(() => {
  //       setCopiedRPC(false);
  //     }, 1200);
  //   };

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/get_domain_whitelist`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setDomainList(res.data.result);
            // setShowDomains(false);
          } else {
            setErrOcc(true);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setErrOcc(true);
        });
    } else {
      //   navigate("/get-api-key");
    }
  }, []);

  const addNewDomain = () => {
    setDomainAddError("");
    const inputDomain = domainAdded.trim();
    if (validateDomain(inputDomain)) {
      setDomainAddStatus("LOADING");
      const token = ReactSession.get("xTkn") ?? "";
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/add_domain_whitelist`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        data: {
          domain: inputDomain,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setDomainAddStatus("SUCCESS");
            setDomainAddError("");
            setDomainList(res.data?.result ?? []);
            setTimeout(() => {
              setDomainAddStatus("UNLOADED");
              setShowAddPanel(false);
              setShowDomains(false);
              //props.navigate(0);
            }, 1500);
          } else {
            setDomainAddStatus("ERROR");
            setDomainAddError(res.data.error);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setDomainAddStatus("ERROR");
          setDomainAddError(
            err.response?.data?.error?.toString() ?? err.message
          );
          setTimeout(() => {
            setDomainAddStatus("UNLOADED");
            setShowAddPanel(false);
            setDomainAddError("");
          }, 2000);
        });
    } else {
      setDomainAddError("Please enter a valid domain");
    }
  };

  const updateIps = (existingDomain, newDomain) => {
    setDomainEditError("");
    existingDomain = existingDomain.trim();
    newDomain = newDomain.trim();
    const token = ReactSession.get("xTkn") ?? "";
    const endPoint = process.env.REACT_APP_AUTH_EP;
    if (newDomain === existingDomain) {
      console.log("Domains are the same");
      return;
    }
    if (token === "") return;
    if (validateDomain(newDomain) && validateDomain(existingDomain)) {
      setDomainEditStatus("LOADING");
      axios({
        url: `${endPoint}dashboard/modify_domain_whitelist`,
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        data: {
          new_domain: newDomain,
          old_domain: existingDomain,
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            setDomainEditStatus("SUCCESS");
            setDomainEditError("");
            setDomainList(res.data?.result ?? []);
            setTimeout(() => {
              setDomainEditStatus("UNLOADED");
              setShowDomains(false);
            }, 1500);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          setDomainEditError(
            err.response?.data?.error?.toString() ?? err.message
          );
          setDomainEditStatus("ERROR");
          setTimeout(() => {
            setDomainEditStatus("UNLOADED");
          }, 2500);
        });
    } else {
      setDomainEditError("Please enter a valid domain");
      setTimeout(() => {
        setDomainEditError("");
        setShowDomains(false);
      }, 3000);
    }
  };

  const deleteIp = (domainToDelete) => {
    setDomainEditError("");
    console.log("Deleting IP: ", domainToDelete);

    const token = ReactSession.get("xTkn") ?? "";

    if (token === "") return;

    if (!validateDomain(domainToDelete)) {
      setDomainEditError("Invalid Ip to delete");
      setShowDomains(false);
    }
    setDomainEditStatus("LOADING");
    const endPoint = process.env.REACT_APP_AUTH_EP;

    axios({
      url: `${endPoint}dashboard/remove_domain_whitelist`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": "69420",
      },
      data: {
        domain: domainToDelete,
      },
    })
      .then((res) => {
        if (res.data.success === true) {
          setDomainEditStatus("SUCCESS");
          setDomainEditError("");
          setDomainList(res.data?.result ?? []);
          // setDeleteNow(false);
          setTimeout(() => {
            setDomainEditStatus("UNLOADED");
            // setShowAddPanel(false);
            // setShowIps(false);
            //props.navigate(0);
          }, 1500);
        }
      })
      .catch((err) => {
        console.log(err);
        setDomainEditStatus("ERROR");
        setDomainEditError(
          err.response?.data?.error?.toString() ?? err.message
        );
        setTimeout(() => {
          setDomainEditStatus("UNLOADED");
        }, 2500);
      });
  };

  function validateDomain(url) {
    try {
      const parsed = new URL(url);
      const hostname = parsed.hostname;

      // Accept localhost
      if (hostname === "localhost") return true;

      // Reject IP addresses
      if (/^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) return false;

      // Accept valid domain names
      const domainPattern = /^[a-z0-9]+([\-\.][a-z0-9]+)*\.[a-z]{2,}$/i;
      return domainPattern.test(hostname);
    } catch {
      return false;
    }
  }
  return (
    <div>
      <Modal
        isOpen={showDomains}
        onClose={() => setShowDomains(false)}
        blockScrollOnMount={true}
        size={"lg"}
      >
        <ModalOverlay />
        <ModalContent
          bg={"brand.black"}
          border={"1px solid"}
          borderColor={"brand.midGrey"}
          borderRadius={"xl"}
        >
          {domainEditStatus === "LOADING" && (
            <Box
              bg={"#0a0a0aaa"}
              width={"full"}
              height={"94%"}
              position={"absolute"}
              zIndex={99}
              marginTop={"10px"}
              borderRadius={"10px"}
            >
              <Box
                position={"relative"}
                zIndex={200}
                marginLeft={"40%"}
                marginTop={"80px"}
              >
                <div className="lds-ellipsis">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </Box>
            </Box>
          )}
          {domainEditStatus === "SUCCESS" && (
            <Box
              bg={"#0a0a0aaa"}
              width={"full"}
              height={"94%"}
              position={"absolute"}
              zIndex={99}
              marginTop={"10px"}
              borderRadius={"10px"}
            >
              <Flex
                width={"full"}
                height={"full"}
                justifyContent={"center"}
                alignItems={"center"}
                zIndex={100}
              >
                <FaCheck size={32} color={"green"} />
              </Flex>
            </Box>
          )}
          {domainEditStatus === "ERROR" && (
            <Box
              bg={"#0a0a0aaa"}
              width={"full"}
              height={"94%"}
              position={"absolute"}
              zIndex={99}
              marginTop={"10px"}
              borderRadius={"10px"}
            >
              <Flex
                width={"full"}
                height={"full"}
                justifyContent={"center"}
                alignItems={"center"}
                zIndex={100}
              >
                <ImCross size={32} color={"red"} />
              </Flex>
            </Box>
          )}
          <ModalCloseButton color={"brand.white"} />
          <ModalBody py={4}>
            {showAddPanel ? (
              <Box>
                <Text
                  as="div"
                  fontSize={{ base: "md", md: "xl" }}
                  fontWeight={"600"}
                  color={"brand.white"}
                  textAlign={"center"}
                  fontFamily={"heading"}
                  paddingBottom={8}
                >
                  Whitelist Domain
                </Text>
                <Box>
                  <Flex>
                    <Input
                      type="text"
                      placeholder="whitelist a new domain"
                      w={"full"}
                      bg={"brand.black"}
                      border={"1px solid"}
                      borderColor={"brand.midGrey"}
                      color={"brand.white"}
                      size={"sm"}
                      borderRadius={"8px"}
                      onChange={(e) => setDomainAdded(e.target.value)}
                    />
                    <Box w={"8px"}></Box>
                    {domainAddStatus === "UNLOADED" && (
                      <Button
                        bg={"brand.red"}
                        color={"brand.white"}
                        border={"1px solid"}
                        borderColor={"brand.red"}
                        _hover={{ bg: "brand.red" }}
                        onClick={addNewDomain}
                        size={"sm"}
                        borderRadius={"8px"}
                        px={4}
                      >
                        Add
                      </Button>
                    )}
                    {domainAddStatus === "LOADING" && (
                      <Box width={"50px"} pt={2}>
                        <BeatLoader color="#fff" loading={true} size={10} />
                      </Box>
                    )}
                    {domainAddStatus === "SUCCESS" && (
                      <Box width={"50px"} pt={2} ps={4}>
                        <FaCheck color="#39e75f" />
                      </Box>
                    )}
                    {domainAddStatus === "ERROR" && (
                      <Box width={"50px"} pt={2} ps={4}>
                        <ImCross color="#e3242b" />
                      </Box>
                    )}
                  </Flex>
                  {ipAddError !== "" && (
                    <Text mt={4} textColor={"brand.red"} fontSize={"sm"}>
                      {ipAddError}
                    </Text>
                  )}
                </Box>
                <Flex justifyContent={"center"} width={"full"} mt={6} mb={1}>
                  <Button
                    size={"sm"}
                    bg={"black"}
                    color={"brand.white"}
                    border={"1px solid"}
                    borderColor={"brand.red"}
                    _hover={{ bg: "brand.red" }}
                    onClick={() => setShowAddPanel(false)}
                  >
                    Cancel
                  </Button>
                </Flex>
              </Box>
            ) : (
              <Box>
                <Text
                  as="div"
                  fontSize={{ base: "md", md: "xl" }}
                  fontWeight={"600"}
                  color={"brand.white"}
                  textAlign={"center"}
                  fontFamily={"heading"}
                  paddingBottom={8}
                >
                  Whitelisted Domains
                </Text>
                {domainList.length > 0 && (
                  <Box>
                    <Box
                      borderBottom={"1px dotted"}
                      borderColor={"#e3353566"}
                      textColor={"brand.yellow"}
                      fontWeight={"400"}
                      fontSize={"sm"}
                      pb={2}
                      fontFamily={"heading"}
                    >
                      <Flex>
                        <Box flex={1} ps={1}></Box>
                        <Box flex={4}>Domain</Box>
                        <Box flex={2} width={"150px"} textAlign={"right"}></Box>
                      </Flex>
                    </Box>
                    <Box
                      maxH={domainList.length < 5 ? "auto" : "400px"}
                      overflowY={domainList.length < 5 ? "auto" : "scroll"}
                    >
                      {/* map this section */}
                      {domainList.map((ipAddress, index) => (
                        <Box
                          key={index}
                          textColor={"brand.lighterWhite"}
                          fontWeight={"400"}
                          fontSize={"sm"}
                          pt={3}
                          pb={1}
                          fontFamily={"heading"}
                        >
                          <CustomControlsExample
                            id={index + 1}
                            textvalue={ipAddress}
                            deletevalue={ipAddress}
                            setShowIps={setShowDomains}
                            navigate={props.navigate}
                            currentIps={domainList}
                            setCurrentIps={setDomainList}
                            ipEditError={domainEditError}
                            setIpEditError={setDomainEditError}
                            ipEditValue={domainEditValue}
                            setIpEditValue={setDomainEditValue}
                            updateIps={updateIps}
                            validateIPaddress={validateDomain}
                            ipEditStatus={domainEditStatus}
                            deleteIp={deleteIp}
                          />
                        </Box>
                      ))}
                    </Box>

                    {domainEditError !== "" && (
                      <Text color={"brand.red"} fontSize={"xs"}>
                        {domainEditError}
                      </Text>
                    )}
                    <Box
                      borderTop={"1px dashed"}
                      borderColor={"#d9d9d988"}
                      marginTop={"10px"}
                    ></Box>
                  </Box>
                )}
                {domainList.length === 0 && (
                  <Box>
                    <Text color={"brand.lighterWhite"} fontSize={"sm"}>
                      You have not whitelisted any URL.
                    </Text>
                  </Box>
                )}
                <Text color={"brand.lighterWhite"} fontSize={"sm"} mt={6}>
                  {domainEditValue}
                </Text>
                {domainList.length < 20 ? (
                  <Flex justifyContent={"center"} width={"full"} mt={6} mb={1}>
                    <Button
                      size={"sm"}
                      bg={"black"}
                      color={"brand.white"}
                      border={"1px solid"}
                      borderColor={"brand.red"}
                      _hover={{ bg: "brand.red" }}
                      onClick={() => setShowAddPanel(true)}
                    >
                      Add New Domain
                    </Button>
                  </Flex>
                ) : (
                  <Box w={"full"} height={"18px"}></Box>
                )}
              </Box>
            )}
          </ModalBody>

        </ModalContent>
      </Modal>
      <Container maxW={"8xl"}>
        <Box
          as="div"
          
          borderRadius={"14px"}
        >
          <Box>
            <Text
              as={"div"}
              fontFamily={"heading"}
              color={"brand.white"}
              fontSize={"2xl"}
              lineHeight={"3xl"}
              fontWeight={"600"}
              position={"relative"}
            >
              Shyft RPC Nodes
            </Text>

            <Text
              as={"div"}
              fontSize={{ base: "14px", lg: "md" }}
              fontWeight={"400"}
              color={"brand.lighterWhite"}
              pt={{ base: "4px", md: "6px" }}
            >
              High performance region optimised Solana RPC nodes. Engineered for
              uptime and throughput.
            </Text>
          </Box>
        </Box>

        <Box as="div">
          <RpcMap apikey={apiKeyString} />
        </Box>

        <Box mt={12} pb={10}>
          <Flex justifyContent={"space-between"} alignItems={"center"} px={1}>
            <Text
              fontSize={{ base: "lg", md: "xl" }}
              fontFamily={"heading"}
              fontWeight={"600"}
              color={"brand.white"}
            >
              Whitelisted Domains
            </Text>
          </Flex>
          <Box as="div">
            <Box
              as="div"
              bg="black"
              px={{ base: "16px", md: "24px", xl: "32px" }}
              py={{ base: "8px", md: "10px", xl: "10px" }}
              borderRadius={"14px"}
              border={"2px solid"}
              borderColor={"brand.red"}
            >
              <TableContainer>
                <Table variant="simple" className="overview_table">
                  <Thead fontFamily={"heading"}>
                    <Tr>
                      <Th
                        textTransform={"capitalize"}
                        fontSize={"md"}
                        fontWeight={"400"}
                        letterSpacing={"0px"}
                        width={"100px"}
                      >
                        {""}
                      </Th>
                      <Th
                        textTransform={"capitalize"}
                        fontSize={"md"}
                        fontWeight={"400"}
                        letterSpacing={"0px"}
                        textAlign={"center"}
                        width={"500px"}
                      >
                        <Text as="span" color={"#fff"} fontWeight={"600"}>
                          Domain List
                        </Text>
                      </Th>
                      <Th
                        textTransform={"capitalize"}
                        fontSize={"md"}
                        fontWeight={"400"}
                        letterSpacing={"0px"}
                        textAlign={"center"}
                      ></Th>

                      <Th
                        isNumeric
                        textTransform={"capitalize"}
                        fontSize={"md"}
                        fontWeight={"400"}
                        letterSpacing={"0px"}
                        width={"100px"}
                      >
                        <Text as="span" color={"#fff"} fontWeight={"600"}>
                          Edit
                        </Text>
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    <Tr>
                      <Td width={"100px"}>1</Td>
                      <Td className="center">
                        <Flex justifyContent={"center"} alignItems={"center"}>
                          {domainList.length === 0 && (
                            <Text as={"span"} color={"brand.lighterWhite"}>
                              All IPs Enabled
                            </Text>
                          )}
                          {domainList.length > 0 && (
                            <Box>
                              {domainList.length > 0 && (
                                <Box
                                  as="div"
                                  display={"inline-block"}
                                  bgColor={"brand.red"}
                                  px={2}
                                  py={1}
                                  mx={1}
                                  borderRadius={6}
                                  fontSize={"0.9em"}
                                  fontWeight={"600"}
                                >
                                  {domainList[0]}
                                </Box>
                              )}
                              {domainList.length > 1 && (
                                <Box
                                  as="div"
                                  display={"inline-block"}
                                  bgColor={"brand.red"}
                                  px={2}
                                  py={1}
                                  mx={1}
                                  borderRadius={6}
                                  fontSize={"0.9em"}
                                  fontWeight={"600"}
                                >
                                  {domainList[1]}
                                </Box>
                              )}
                              {domainList.length > 2 && (
                                <Box
                                  as="div"
                                  display={"inline-block"}
                                  bgColor={"brand.yellow"}
                                  color={"brand.black"}
                                  px={2}
                                  py={1}
                                  mx={1}
                                  borderRadius={"full"}
                                  fontSize={"0.9em"}
                                  fontWeight={"600"}
                                >
                                  +{domainList.length - 2}
                                </Box>
                              )}
                            </Box>
                          )}
                        </Flex>
                      </Td>
                      <Td className="center">All Regions Enabled</Td>

                      <Td width={"100px"}>
                        <IconButton
                          size={"sm"}
                          bg={"transparent"}
                          color={"brand.yellow"}
                          _hover={{ bg: "transparent" }}
                          onClick={() => setShowDomains(true)}
                        >
                          <BsFillGearFill size={"20"} color="#fff" />
                        </IconButton>
                      </Td>
                    </Tr>
                  </Tbody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
      </Container>
    </div>
  );
};

export default Rpcs;
